import { MeResponse } from '@atlassiansox/asc-stargate';

import {
	AisSitesType,
	AvailableProductsResponse,
} from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { useLoggedInUser } from '../../../utils/logged-in-user-provider';

export enum AtlSiteType {
	CONFLUENCE = 'confluence.ondemand',
	JIRA = 'jira-software.ondemand',
}

interface useLogMeInProps {
	availableProducts: AvailableProductsResponse | null;
	userProfile: MeResponse | null;
	siteType: AtlSiteType;
}

interface useLogMeInResponse {
	userProfileName: string | undefined;
	recentSites: AisSitesType[];
	shouldShowLogMeIn: boolean;
}

const filterAvailableSites = (
	availableProducts: AvailableProductsResponse | null,
	siteType: AtlSiteType,
): AisSitesType[] => {
	if (availableProducts) {
		const filteredSites =
			availableProducts.sites.filter((site) => {
				return site.products.includes(siteType);
			}) || [];

		return filteredSites;
	} else {
		return [];
	}
};

export const useLogMeIn = ({
	availableProducts,
	userProfile,
	siteType = AtlSiteType.CONFLUENCE,
}: useLogMeInProps): useLogMeInResponse => {
	const filteredSites = filterAvailableSites(availableProducts, siteType);
	const loggedInUserName = useLoggedInUser().name;
	const userProfileName = userProfile?.name || loggedInUserName;

	return {
		userProfileName,
		recentSites: filteredSites,
		shouldShowLogMeIn: !!userProfileName && filteredSites.length > 0,
	};
};
